import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc, updateDoc, collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";

function EditOrder() {
  const { orderId } = useParams();
  const navigate = useNavigate();

  const [order, setOrder] = useState(null);
  const [items, setItems] = useState([]);
  const [skuMaster, setSkuMaster] = useState([]);

  // ------------------------------
  // LOAD SKU MASTER
  // ------------------------------
  // Load SKU master in map format
const loadSkuMaster = async () => {
  const snap = await getDocs(collection(db, "skuMaster"));
  const map = {};

  snap.docs.forEach((d) => {
    const data = d.data();
    const key = data.sku?.trim().toUpperCase();   // 🔥 MATCH ORDER SKU EXACTLY
    if (key) map[key] = data;
  });

  setSkuMaster(map);
};

// Get SKU details
const getSkuDetails = (skuName) => {
  const key = skuName.trim().toUpperCase();
  return skuMaster[key] || null;
};



  // ------------------------------
  // LOAD ORDER
  // ------------------------------
  const loadOrder = async () => {
    const ref = doc(db, "orders", orderId);
    const snap = await getDoc(ref);

    if (snap.exists()) {
      const data = snap.data();

      // Convert items object → array
      const mapped = Object.entries(data.items).map(([skuName, qty]) => ({
        sku: skuName,
        qty: qty,
        approvedQty: qty,
      }));

      setOrder(data);
      setItems(mapped);
    }
  };

  useEffect(() => {
  loadSkuMaster().then(loadOrder);
}, [orderId]);

  // ------------------------------
  // UPDATE QTY IN STATE
  // ------------------------------
  const updateQty = (index, value) => {
    const updated = [...items];
    updated[index].approvedQty = Number(value);
    setItems(updated);
  };

  // ------------------------------
  // APPROVE ORDER
  // ------------------------------
  const approveOrder = async () => {
    const email = localStorage.getItem("email");

    await updateDoc(doc(db, "orders", orderId), {
      status: "APPROVED",
      approvedBy: email,
      approvedAt: new Date().toISOString(),
      items: items,
    });

    alert("Order approved!");
    navigate("/pending-orders");
  };

  if (!order) return <h2>Loading...</h2>;

  return (
    <div style={{ padding: "20px" }}>
      <h2>Edit & Approve Order</h2>
      <p>Order Date: {order.orderDate}</p>
      <p>Party: {order.partyName}</p>

      <table border="1" cellPadding="8" width="100%">
        <thead>
          <tr>
            <th>SKU</th>
            <th>Description</th>
            <th>Qty</th>
            <th>Basic</th>
            <th>GST</th>
            <th>CESS</th>
            <th>Addl Cess</th>
            <th>Total</th>
            <th>Approved Qty</th>
          </tr>
        </thead>

        <tbody>
          {items.map((it, index) => {
            
			
			const sku = getSkuDetails(it.sku);

// If SKU not found → show NOT FOUND row
if (!sku) {
  return (
    <tr key={index}>
  {/* SKU CODE */}
  <td>{it.sku}</td>

  {/* DESCRIPTION */}
  <td>{sku.description || sku.Name || ""}</td>

  {/* QTY */}
  <td>{it.qty}</td>

  {/* RATE */}
  <td>{sku.rate || 0}</td>

  {/* BASIC */}
  <td>{basic.toFixed(2)}</td>

  {/* GST */}
  <td>{gstAmt.toFixed(2)}</td>

  {/* CESS */}
  <td>{cessAmt.toFixed(2)}</td>

  {/* ADDL CESS */}
  <td>{addlCessAmt.toFixed(2)}</td>

  {/* TOTAL */}
  <td>{total.toFixed(2)}</td>

  {/* APPROVED QTY */}
  <td>
    <input
      type="number"
      value={it.approvedQty}
      onChange={(e) => updateQty(index, e.target.value)}
    />
  </td>
</tr>

  );
}


// SAFE numeric values
const basicPerUnit = Number(sku.Basic_Eway || 0);
const gstPct = Number(sku.gst || 0);
const cessPct = Number(sku.cess || 0);
const addlCess = Number(sku.addlcess || 0);
const rebate = Number (sku.Rebate || 0);

const basic = basicPerUnit * it.approvedQty;
const gstAmt = (basic * gstPct) / 100;
const cessAmt = (basic * cessPct) / 100;
const addlCessAmt = addlCess * it.approvedQty;
const rebateAmt = rebate * it.approvedQty;

const total = basic + gstAmt + cessAmt + addlCessAmt + rebateAmt ;

return (
  <tr key={index}>
    <td>{it.sku}</td>
	
	// raviprabu changed to check SKU to come in the pending edit order page
    <td>{sku.sku || sku.description || ""}</td>

    <td>{it.qty}</td>
    <td>{basic.toFixed(2)}</td>
    <td>{gstAmt.toFixed(2)}</td>
    <td>{cessAmt.toFixed(2)}</td>
    <td>{addlCessAmt.toFixed(2)}</td>
    <td>{total.toFixed(2)}</td>
    <td>
      <input
        type="number"
        value={it.approvedQty}
        onChange={(e) => updateQty(index, e.target.value)}
      />
    </td>
  </tr>
);

             
          })}
        </tbody>
      </table>

      <button
        style={{ marginTop: "20px", padding: "10px 20px" }}
        onClick={approveOrder}
      >
        Approve Order
      </button>
    </div>
  );
}

export default EditOrder;
